import { useValidate } from "formvalidation/hooks";
import React, { useRef } from "react";
import { InputBase } from "./Atoms/formInputs/InputBase";

interface Props {
  value: string
  onChange: (newCode: string) => void
  validationKey: string
}

const alphaNumericRegex = /^[A-Za-z0-9]+$/;

const BookkeepingInput = (props: Props) => {
  const validateBookkeepingCode = (newCode: string): string | boolean => {
    const doesntHaveThreeCharacters = newCode.length !== 3;
    if (doesntHaveThreeCharacters) {
      return false
    }

    const hasInvalidChars = (alphaNumericRegex.exec(newCode)) == null;
    if (hasInvalidChars) {
      return false
    }

    return true;
  };

  const inputRef = useRef<HTMLInputElement>(null);

  const validation = useValidate({
    key: props.validationKey,
    title: "Bookkeeping code",
    value: props.value,
    validate: async () => validateBookkeepingCode(props.value),
    ref: inputRef,
  })

  return <InputBase
    ref={inputRef}
    value={props.value?.toUpperCase()}
    onChange={value => { props.onChange(value?.toUpperCase()); }}
    error={validation.error.hasError}
    maxLength={3}
  />;
};

export default BookkeepingInput;